import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-simple-card',
  templateUrl: './simple-card.component.html',
  styleUrls: ['./simple-card.component.scss'],
})
export class SimpleCardComponent implements OnInit {
  @Input() item;
  innerHtml;
  constructor() {}

  ngOnInit(): void {
    let finalData = JSON.parse(this.item.content);
    console.log(finalData);
    // this.innerHtml = finalData.chunks.body;
    this.innerHtml = finalData.html;
  }
}
